import { Button } from 'components/button/Button'
import { GuidebookHero } from 'components/content/guidebook/guidebookHero/GuidebookHero'
import { useTranslation } from 'next-i18next'
import Router from 'next/router'
import { useAuth } from 'utils/auth/hooks/useAuth'

export function GuidebookCreateAccount() {
  const { isLogged } = useAuth()
  const { t } = useTranslation('eol_guide')

  return (
    <GuidebookHero
      title={t('eol_guide.section_signup.title')}
      titleAs="h2"
      description={t('eol_guide.section_signup.description')}
      action={
        <Button
          type="button"
          size="large"
          onClick={() => {
            Router.push(isLogged ? '/me/dashboard' : '/signup')
          }}
        >
          {t('eol_guide.section_signup.cta')}
        </Button>
      }
      image={<img src={`/images/guidebook/hero-image2@2x.jpg`} />}
    />
  )
}
